import { useState } from "react";
import { Menu, X, WalletIcon, User } from "lucide-react";
import { Link } from "react-router-dom";
import { Translator } from "./translate";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { money } from "../../utilities/currency";

export function Header({ wallet, scrolled, T, onLoginClick, currentUser, onLogout, baseUrl }) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [showLogin, setShowLogin] = useState(false);


    const client = useSelector((state) => state.client.client);
    const default_configs = client ? JSON.parse(client.default_configs) : "";
    const footer_settings = client ? JSON.parse(client.footer_settings) : null;

    const logo = baseUrl.includes("localhost") ? "https://localhost/chamcore/chameleon/uploads/clients/logo/" + footer_settings?.logo_home : "https://chamcore.com/chameleon/uploads/clients/logo/" + footer_settings?.logo_home;

    /* inside your component where showLogin state exists */
    useEffect(() => {
        function onKeyDown(e) {
            if (e.key === "Escape") setShowLogin(false);
        }
        if (showLogin) {
            window.addEventListener("keydown", onKeyDown);
            // prevent background scrolling while modal is open
            document.body.style.overflow = "hidden";
        }
        return () => {
            window.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = "";
        };
    }, [showLogin]);

    return (
        <>
            <div className="relative text-black text-sm font-medium flex items-center justify-center">
                {/* Centered content */}
                <div className="flex items-center gap-4">
                    <span className={`${default_configs?.wallet_payment === "yes" ? "sm:flex" : "hidden"}`}>
                        {T.offer}
                    </span>

                    <div
                        className={`${default_configs?.wallet_payment === "yes" &&
                            currentUser &&
                            currentUser.role === "customer"
                            ? "flex"
                            : "hidden"
                            } items-center gap-2 rounded-full px-3 py-1 bg-white/10`}
                    >
                        <WalletIcon className="w-4 h-4" />
                        <span className="text-sm font-semibold">{money(wallet)}</span>
                    </div>
                </div>

                {/* Right-aligned dark mode button */}
                {/* <Button
                    variant="ghost"
                    onClick={() => {
                        const newMode = !darkMode;
                        setDarkMode(newMode);
                        localStorage.setItem("darkMode", newMode);
                    }}
                    className="absolute right-4 rounded-full text-white"
                >
                    {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                </Button> */}
            </div>
            <header
                className={`sticky top-0 z-50 transition-shadow bg-white/80 text-gray-900 backdrop-blur ${scrolled ? "shadow-md" : ""}`}
            >
                <div className="max-w-7xl mx-auto flex justify-between items-center p-4">
                    {/* Left: Logo + Menu */}
                    <div className="flex items-center gap-2">
                        {/* <button
                            className="md:hidden"
                            onClick={() => setMobileOpen(!mobileOpen)}
                            aria-label="Toggle Menu"
                        >
                            {mobileOpen ? (
                                <X className="w-6 h-6 text-purple-700" />
                            ) : (
                                <Menu className="w-6 h-6 text-purple-700" />
                            )}
                        </button> */}
                        <h1 className="text-xl font-bold">
                            <Link
                                to="/"
                                className="flex items-center gap-2" // 👈 makes logo & text inline
                            >
                                <img
                                    src={logo}
                                    alt={client.name}
                                    className="h-8 w-auto" // 👈 keeps consistent size
                                />
                                {footer_settings?.logo_home_not_sqaure ? (
                                    <span>{footer_settings.company_brand_name}</span>
                                ) : null}
                            </Link>
                        </h1>
                    </div>

                    {/* Right: Translator always visible */}
                    <div className="flex items-center gap-4">
                        {/* <Translator /> */}
                        {/* Desktop buttons only */}
                        <div className="flex items-center gap-4">
                            {currentUser ? (
                                <>
                                    <Link
                                        to={currentUser.role === "agent" ? "/agent/dashboard" : currentUser.role === "support" || currentUser.role === "client" ? "/support_admin/dashboard" : "/customer/dashboard"}
                                        className="font-medium hover:text-purple-700"
                                    >
                                        Hello, {currentUser.name}
                                    </Link>
                                    <button onClick={onLogout} className="hover:text-purple-700 font-medium">
                                        Logout
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button onClick={onLoginClick} className="hover:text-purple-700 font-medium">
                                        <User />
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                    {/* <AnimatePresence>
                        {mobileOpen && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.3, ease: "easeInOut" }}
                                className="md:hidden overflow-hidden px-4 pb-4 flex flex-col gap-3 border-t border-purple-100"
                            >
                                {currentUser ? (
                                    <>
                                        <Link
                                            to={currentUser.role === "agent" ? "/agent/dashboard" : "/customer/dashboard"}
                                            className="font-medium hover:text-purple-700"
                                        >
                                            Hello, {currentUser.name}
                                        </Link>
                                        <button onClick={onLogout} className="hover:text-purple-700 font-medium">
                                            Logout
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button onClick={onLoginClick} className="hover:text-purple-700 font-medium">
                                            <User />
                                        </button>
                                    </>
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence> */}
                </div>
            </header>
        </>
    );
}